import { Directive, Input } from '@angular/core';
import posthog from 'posthog-js';

@Directive({
  selector: '[obTrackClick]',
  standalone: true,
  host: {
    '(click)': 'onClick()',
  },
})
export class TrackClickDirective {
  @Input() obTrackClick!: string;
  @Input() trackProperties?: object;

  onClick(): void {
    posthog.capture(this.obTrackClick, this.trackProperties);
  }
}
